import {
	GET_EVENTS,
	FETCH_EVENT,
	UPDATE_EVENT,
	DELETE_EVENT,
	UPDATE_EVENT_PAGE_NUMBER,
} from "constants/actions";

const initialState = {
	events: [],
	pageNumber: 1,
	pending: false,
	updated: false,
	created: [],
	queryParams: [],
};

export default function ActionEvents(state = initialState, action) {
	switch (action.type) {
		case UPDATE_EVENT_PAGE_NUMBER:
			return {
				...state,
				pageNumber: action.payload,
			};

		case GET_EVENTS:
			return {
				...state,
				events: action.payload,
				pending: false,
				updated: false,
			};

		case FETCH_EVENT:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case UPDATE_EVENT:
			if (state.events && Array.isArray(state.events)) {
				const exists = state.events.find((e) => e.id === action.payload.id);
				const events = exists
					? state.events.map((e) => (e.id === action.payload.id ? action.payload : e))
					: [...state.events, action.payload];

				return {
					...state,
					events,
					[action.payload.id]: action.payload,
					pending: false,
					updated: action.payload,
				};
			}

			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
				updated: action.payload,
			};

		case DELETE_EVENT:
			return {
				...state,
				events: (state.events || []).filter((row) => row.id !== action.payload),
				pending: false,
				updated: true,
			};

		default:
			return state;
	}
}

